
import React from 'react';
import { createAsyncThunk } from '@reduxjs/toolkit';
import Config from '../../../Config';
import ProviderManager from '../../../provider/providerManager';
import signalRService from "app/utilities/signalR/SignalRService";
import { SignalRConstants } from "app/utilities/signalR/SignalRConstants";
import { showAppLoader, hideAppLoader  } from '../../Shared/Loader/LoaderSlice';
import ErrorsEnum from "./constant/ErrorsEnum";
import PageEnum  from "./constant/PageEnum";
import StepsEnum from "./constant/StepsEnum";
import WizardEnum from "./constant/WizardEnum";
import PopupTypeEnum from './constant/PopupTypeEnum';
import { goToPage , setIsShowPopup, setIsShowExtendedOtpPopup , reportDWH } from 'app/Components/Block/LocalCellularTroubleshootingWizardBlock/LocalCellularTroubleshootingWizardBlockSlice';
import { setRetainSubscriberOnLoad, getSubscriberDetails } from 'app/Components/Page/SelfCarePage/SelfCareSlice';
import ErrorIcon from "app/Components/Block/LocalCellularTroubleshootingWizardBlock/images/error.svg";
import FinancialErrorIcon from "app/Components/Block/LocalCellularTroubleshootingWizardBlock/images/creditcard.svg";
import alertIcon from "app/Components/Block/LocalCellularTroubleshootingWizardBlock/images/alert-icon.svg";
import SuccessIcon from "app/Components/Block/LocalCellularTroubleshootingWizardBlock/images/success-icon.svg";

export const goToPageAsync = createAsyncThunk('localCellularTroubleshootingWizardBlock/goToPageAsync', async (data, thunkAPI) => {
    try {
        const localCellularTroubleshootingWizardBlock = thunkAPI.getState().localCellularTroubleshootingWizardBlock;
        const wizardTypeName = localCellularTroubleshootingWizardBlock.wizardTypeName;
        const loginData = thunkAPI.getState().authentication?.loginData;
        const epiBlockData = localCellularTroubleshootingWizardBlock.epiBlockData;
        const selectedSubscriber = localCellularTroubleshootingWizardBlock.subscriber;
        const details = data.details ?? localCellularTroubleshootingWizardBlock.details;
        const pageType = data.pageType;
        const resultMessage = data.resultMessage ?? '';
        const messageText = data.messageText ?? '';
        const dwhWizardName = localCellularTroubleshootingWizardBlock.dwhWizardName;
        let pageContent = {type: '' , icon: ErrorIcon , title: '' , subTitle: '' , isDisplayCallBack: false , links: [] , selections: [] , alert: null , buttons: [] , textAboveButtons: '' , popup: {type: '' , icon: null ,title: '' , text: '' , buttonText: '' , onClick: ''}};
        switch (pageType) {
            //PRELIMINARY TESTS
            case ErrorsEnum.NO_CELLULAR_SUBSCRIBER:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>אנחנו לא מזהים שיש לך<br/>מנוי סלולר ב{window.Config.brand_Name_HE}</>);
                pageContent.subTitle = (<>יכול להיות שנרשמתם עם פרטים אחרים?<br/>שווה לנסות להתחבר שוב</>);
                pageContent.links = [{text: 'להצטרפות לשירות' , link: Config.joinCellularServiceLink}]
            break;
            case ErrorsEnum.BUSINESS_SUBSCRIBER:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>מנוי {selectedSubscriber} הינו עיסקי<br/>יש לפנות לאיש הקשר בארגונך<br/>למתן שירות</>)
            break;
            case ErrorsEnum.FINANCIAL_DEBT_ERROR:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.icon = FinancialErrorIcon;
                pageContent.title = (<>לפני שנמשיך בתהליך<br/>יש לשלם את החוב בחשבון</>);
                pageContent.links = [{text: 'לתשלום חוב' , link: Config.payDebtLink}]
            break;
            case ErrorsEnum.FINANCIAL_PAYMENT_UPDATE_ERROR:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.icon = FinancialErrorIcon;
                pageContent.title = (<>לפני שנמשיך בתהליך<br/>יש לעדכן אמצעי תשלום ב{window.Config.brand_Name_HE}</>);
                pageContent.links = [{text: 'לעדכון אמצעי תשלום' , link: Config.updatePaymentMethodLink}]
            break;
            case ErrorsEnum.FINANCIAL_PAYMENT_UPDATE_AND_DEBT_ERROR:
            case ErrorsEnum.FINANCIAL_PAYMENT_METHOD_UPDATE_ERROR:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.icon = FinancialErrorIcon;
                pageContent.title = (<>לפני שנמשיך בתהליך<br/>יש לשלם את החוב בחשבון<br/>ולעדכן אמצעי תשלום</>);
                pageContent.links = [{text: 'לתשלום חוב' , link: Config.payDebtLink},{text: 'לעדכון אמצעי תשלום' , link: Config.updatePaymentMethodLink} ]
            break;
            case ErrorsEnum.SUSPENDED_SUBSCRIBER:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>מנוי {selectedSubscriber} מושהה</>);
                pageContent.subTitle = (<>לא ניתן לבצע פעולות בסטטוס מושהה<br/>לפרטים נוספים יש לפנות לנציג שירות</>);
                pageContent.isDisplayCallBack = true;
            break;
            case ErrorsEnum.SUSPENDED_SUBSCRIBER_LOST_OR_STOLEN:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>מנוי {selectedSubscriber} מושהה בעקבות<br/> דיווח על אובדן או גניבה</>);
                pageContent.subTitle = (<>לא ניתן לבצע פעולות בסטטוס מושהה<br/>לפרטים נוספים יש לפנות לנציג שירות</>);
                pageContent.isDisplayCallBack = true;
            break;
            case ErrorsEnum.DATA_ONLY:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>מנוי זה מיועד לדאטה בלבד<br/>ולכן שיחות והודעות לא נתמכות</>);
            break;
            case ErrorsEnum.DEFENSE_POLICY_BLOCKED:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>הקו חסום בהתאם להנחיית<br/>משרד התקשורת</>);
                pageContent.subTitle = (<>לפרטים נוספים ניתן לפנות למשרד התקשורת</>);
            break;
            case ErrorsEnum.KOSHER_SUBSCRIBER:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>זיהינו שהמנוי כשר<br/>ולכן לא יכול לגלוש</>);
            break;
            case ErrorsEnum.NO_REGISTERED:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                const noRegisteredText = wizardTypeName == WizardEnum.LocalCalls ? epiBlockData.calls.callsConnectingToNetworkText : epiBlockData.browsing.browsingConnectingToNetworkText;
                const noRegisteredLink = wizardTypeName == WizardEnum.LocalCalls ? epiBlockData.calls.callsConnectingToNetworkLink : epiBlockData.browsing.browsingConnectingToNetworkLink;
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>הקו לא מחובר לרשת סלולרית</>);
                pageContent.subTitle = (<>כדי להתקדם יש לעקוב אחר ההנחיות<br/>המופיעות במדריך</>);
                pageContent.links = [{text: noRegisteredText , link: noRegisteredLink}]
            break;
            case ErrorsEnum.SUBSCRIBER_ABROAD:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                const subscriberAbroadText = wizardTypeName == WizardEnum.LocalCalls ? epiBlockData.calls.callsLobbyCellularIssuesAbroadText : epiBlockData.browsing.browsingLobbyCellularIssuesAbroadText;
                const subscriberAbroadLink = wizardTypeName == WizardEnum.LocalCalls ? epiBlockData.calls.callsLobbyCellularIssuesAbroadLink : epiBlockData.browsing.browsingLobbyCellularIssuesAbroadLink;
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>זיהינו שהמנוי לא נמצא בארץ</>);
                pageContent.subTitle = (<>האשף מיועד רק למנויים הנמצאים בארץ ולא ניתן לבצע את הבדיקות על מנוי שנמצא בחו״ל</>);
                pageContent.links = [{text: subscriberAbroadText , link: subscriberAbroadLink}]
            break;
            //BROWSING
            case ErrorsEnum.CELLULAR_DATA_OFF_WITHOUT_APN:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>במנוי {selectedSubscriber}<br/>לא קיימת חבילת גלישה בארץ</>);
                pageContent.isDisplayCallBack = true;
            break;
            case ErrorsEnum.CELLULAR_DATA_OFF_WITH_APN:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>במנוי {selectedSubscriber}<br/>לא קיימת חבילת גלישה בארץ<br/>וקיימות הגדרות מיוחדות</>);
                pageContent.isDisplayCallBack = true;
            break;
            case ErrorsEnum.RESTRICTED_BROWSE:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>במנוי {selectedSubscriber}<br/>הסתיימה חבילת הגלישה<br/>היא תתחדש בתאריך {details?.billCycle}</>);
                pageContent.subTitle = (<>באפשרותך לרכוש הרחבת גלישה</>);
                pageContent.links = [{text: epiBlockData.browsing.purchasingBrowsingPackageText , link: epiBlockData.browsing.purchasingBrowsingPackageLink}]
            break;
            case ErrorsEnum.BLOCK_BROWSE:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>מנוי {selectedSubscriber} חסום לגלישה</>);
                pageContent.subTitle = (<>האם ברצונך לפתוח את החסימה?</>);
                pageContent.links = [{text: epiBlockData.browsing.unblockBrowsingText , link: epiBlockData.browsing.unblockBrowsingLink}]
            break;
            case ErrorsEnum.NO_DEFAULT_APN:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>במנוי {selectedSubscriber} קיימות<br/>הגדרות גלישה מיוחדות<br/>נמשיך עם נציג</>);
                pageContent.isDisplayCallBack = true;
            break;
            case ErrorsEnum.NO_ERROR_DATA:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>סיימנו את הבדיקות<br/>ולא מצאנו בעיות בקו</>);
                pageContent.subTitle = (<>כעת, כדי לבדוק שגם הגדרות המכשיר תקינות<br/>מומלץ להמשיך למדריך</>)
                pageContent.links = [{text: epiBlockData.browsing.browsingSmartWizardNotFoundErrorText , link: epiBlockData.browsing.browsingSmartWizardNotFoundErrorLink}]
            break;
            //CALLS
            case StepsEnum.SELECT_CALLS_TYPE:
                pageContent.type = PageEnum.STEP;
                pageContent.title = (<>האם הבעיה בשיחות נכנסות<br/>או יוצאות?</>);
                pageContent.selections = [{text: 'שיחות נכנסות' , nextPage: StepsEnum.CHECK_INCOMING_CALLS }, {text: 'שיחות יוצאות' , nextPage: StepsEnum.CHECK_OUTGOING_CALLS }]
                pageContent.buttons = [{text: 'המשך'}]
            break;
            case StepsEnum.CHECK_INCOMING_CALLS:
                pageContent.type = PageEnum.LOADER;
                pageContent.title = 'בודקים כמה דברים לפני שנמשיך';
                thunkAPI.dispatch(localCallsTroubleshootingWizard({localCallsType : WizardEnum.LocalIncomingCalls }));
            break;
            case StepsEnum.CHECK_OUTGOING_CALLS:
                pageContent.type = PageEnum.LOADER;
                pageContent.title = 'בודקים כמה דברים לפני שנמשיך';
                thunkAPI.dispatch(localCallsTroubleshootingWizard({localCallsType : WizardEnum.LocalOutgoingCalls }));
            break;
            case ErrorsEnum.HAS_FOLLOW_ME:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>בקו {selectedSubscriber} מוגדרת הפניית<br/> שיחות שמונעת לקבל שיחות</>);
                pageContent.subTitle = (<>מומלץ כעת להמשיך למדריך ולבצע<br/> את ההגדרות הרלוונטיות אצלך</>)
                pageContent.links = [{text: epiBlockData.calls.smartWizardToDeviceRedirectionSettingsText , link: epiBlockData.calls.smartWizardToDeviceRedirectionSettingsLink}]
            break;
            case ErrorsEnum.HAS_BLOCK_INCOMING_CALLS:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>קיימת חסימת שיחות במכשיר</>);
                pageContent.subTitle = (<>כדי להתקדם יש לעקוב אחר ההנחיות<br/>המופיעות במדריך</>)
                pageContent.links = [{text: epiBlockData.calls.unblockCallsText , link: epiBlockData.calls.unblockCallsLink}]
            break;
            case ErrorsEnum.HAS_BLOCK_OUTGOING_CALLS:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>קיימת חסימת שיחות<br/>יוצאות במכשיר</>);
                pageContent.subTitle = (<>כדי להתקדם יש לעקוב אחר ההנחיות<br/>המופיעות במדריך</>)
                pageContent.links = [{text: epiBlockData.calls.unblockCallsText , link: epiBlockData.calls.unblockCallsLink}]
            break;
            case ErrorsEnum.NO_ERROR_INCOMING_CALLS:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>סיימנו את הבדיקות<br/>ולא מצאנו בעיות בקו</>);
                pageContent.subTitle = (<>כעת, כדי לבדוק שגם הגדרות המכשיר תקינות<br/>מומלץ להמשיך למדריך</>)
                pageContent.links = [{text: epiBlockData.calls.callsSmartWizardNotFoundErrorText , link: epiBlockData.calls.callsSmartWizardNotFoundErrorLink}]
            break;
            case ErrorsEnum.NO_ERROR_OUTGOING_CALLS:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>סיימנו את הבדיקות<br/>ולא מצאנו בעיות בקו</>);
                pageContent.subTitle = (<>כעת, כדי לבדוק שגם הגדרות המכשיר תקינות<br/>מומלץ להמשיך למדריך</>)
                pageContent.links = [{text: epiBlockData.calls.callsSmartWizardNotFoundErrorText , link: epiBlockData.calls.callsSmartWizardNotFoundErrorLink}]
            break;
            //MABAL
            case StepsEnum.HAS_BLOCK_OUTGOING_CALLS_MABAL:
                const isFullOrExtendedAuthenticated = loginData?.isFullAuthenticated || loginData?.isOtpExtendedAuthenticated ;
                pageContent.type = PageEnum.STEP;
                pageContent.title = (<>מנוי {selectedSubscriber}<br/>לא פתוח לשיחות לחו"ל</>);
                pageContent.subTitle = (<>באפשרותך לאשר פתיחה<br/>ולהתחיל להשתמש בשירות</>)
                pageContent.selections = [{text: 'תפתחו את החסימה' , nextPage: isFullOrExtendedAuthenticated ? StepsEnum.OPEN_OUTGOING_CALLS_MABAL : StepsEnum.SHOW_EXTENDED_OTP_POPUP  }, {text: 'תשאירו חסום' , nextPage: PageEnum.SUCCESS }]
                pageContent.alert = details?.hasMabalPackage ? null : {text: 'במנוי אין חבילת שיחות לחו״ל - חיוג לחו”ל ללא חבילה עלול להיות מחוייב בסכומים גבוהים' , linkObj : {text: epiBlockData.mabal.purchasingMabalText , link: epiBlockData.mabal.purchasingMabalLink}}
                pageContent.buttons = [{text: 'המשך'}]
            break;
            case StepsEnum.OPEN_OUTGOING_CALLS_MABAL:
                pageContent.type = PageEnum.LOADER;
                pageContent.title = (<>פותחים שיחות לחו”ל</>);
                thunkAPI.dispatch(internationalCallUnblocking());
            break;
            case StepsEnum.OPEN_OUTGOING_CALLS_MABAL_SUCCESS:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: 'OpenInternationalCallsBlock Success', param1: resultMessage }));
                pageContent.type = PageEnum.STEP;
                pageContent.title = (<>זהו, חיוג לחו”ל פתוח</>);
                pageContent.subTitle = (<>יש לבדוק האם ניתן להוציא שיחות לחו״ל</>);
                pageContent.links = [{text: 'לא בטוחים איך לחייג לחו"ל?' , isOpenPopUp : true}];
                pageContent.popup = {type: PopupTypeEnum.HOW_TO_CALL_FROM_ISRAEL ,icon: alertIcon , title: 'איך מחייגים מישראל לחו״ל?' , text: epiBlockData.mabal.dialingInstructions , buttonText: 'הבנתי, תודה'};
                pageContent.alert = details?.hasMabalPackage ? null : {text: 'במנוי אין חבילת שיחות לחו״ל - חיוג לחו”ל ללא חבילה עלול להיות מחוייב בסכומים גבוהים' , linkObj : {text: epiBlockData.mabal.purchasingMabalText , link: epiBlockData.mabal.purchasingMabalLink}}
                pageContent.textAboveButtons = 'האם הבעיה נפתרה?';
                pageContent.buttons = [{text: 'כן' , nextPage: PageEnum.SUCCESS }, {text: 'לא' , nextPage: ErrorsEnum.DEVICE_ACTION_FAILED }];
                break;
            case ErrorsEnum.NO_ERROR_MABAL:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>קו הטלפון פתוח<br/>לחיוג לחו״ל</>);
                pageContent.subTitle = (<>מומלץ לבדוק שאתם מחייגים נכון</>)
                pageContent.links = [{text: 'לא בטוחים איך לחייג לחו"ל?' , isOpenPopUp : true}];
                pageContent.popup = {type: PopupTypeEnum.HOW_TO_CALL_FROM_ISRAEL ,icon: alertIcon , title: 'איך מחייגים מישראל לחו״ל?' , text: epiBlockData.mabal.dialingInstructions , buttonText: 'הבנתי, תודה'};
                pageContent.alert = details?.hasMabalPackage ? null : {text: 'במנוי אין חבילת שיחות לחו״ל - חיוג לחו”ל ללא חבילה עלול להיות מחוייב בסכומים גבוהים' , linkObj : {text: epiBlockData.mabal.purchasingMabalText , link: epiBlockData.mabal.purchasingMabalLink}}
                pageContent.icon = SuccessIcon;
                break;
            //GENERAL
            case ErrorsEnum.ACTION_FAILED:
                const message_text = messageText ? messageText : dwhWizardName + ' General Error';
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Error', messageText: message_text , param1: resultMessage}));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>נסינו לפתור את הבעיה<br/>אבל נצטרך להמשיך עם נציג</>);
                pageContent.isDisplayCallBack = true;
            break;
            case ErrorsEnum.DEVICE_ACTION_FAILED:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Service Needed', messageText: 'Service Needed Page Displayed', param1: resultMessage}));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>אז נמשיך עם נציג</>);
                pageContent.isDisplayCallBack = true;
            break;
            case ErrorsEnum.UNRESOLVED_ISSUE:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>ביצענו את כל הבדיקות הנדרשות ולא מצאנו בעיה בהגדרות הקו</>);
                pageContent.subTitle = (<>מומלץ כעת להמשיך למדריך ולבצע את ההגדרות הרלוונטיות אצלך</>)
                pageContent.isDisplayCallBack = true;
                pageContent.links = [{text: epiBlockData.smartWizardText , link: epiBlockData.smartWizardLink}]
            break;
            //GENERAL STEPS
            case StepsEnum.SUCCESS_SWITCH_MONITOR:
                pageContent.type = PageEnum.STEP;
                pageContent.title = (<>להשלמת ההגדרות יש להדליק<br/>ולכבות מצב טיסה במכשיר</>);
                pageContent.buttons = [{text: 'המשך' , nextPage: StepsEnum.UPDATED_SETTINGS }]
            break;
            case StepsEnum.UPDATED_SETTINGS:
                const updatedSettingsSubTitle = wizardTypeName == WizardEnum.LocalData ?  (<>יש לבדוק את הגלישה כשהמכשיר<br/>לא מחובר ל-WiFi</>) : '';
                pageContent.type = PageEnum.STEP;
                pageContent.title = (<>האם הבעיה נפתרה?</>);
                pageContent.subTitle = updatedSettingsSubTitle;
                pageContent.selections = [{text: 'כן, תודה' , nextPage: PageEnum.SUCCESS }, {text: 'עדיין לא עובד לי' , nextPage: ErrorsEnum.DEVICE_ACTION_FAILED }]
                pageContent.buttons = [{text: 'המשך'}]
            break;
            case StepsEnum.SHOW_EXTENDED_OTP_POPUP:
                thunkAPI.dispatch(setRetainSubscriberOnLoad(true));
                thunkAPI.dispatch(setIsShowExtendedOtpPopup(true));
            break;
            //GENERAL_ERROR
            case ErrorsEnum.GENERAL_ERROR:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Error', messageText: 'General Error', param1: resultMessage}));
                pageContent.type = PageEnum.ERROR;
                pageContent.title = (<>נסינו לפתור את הבעיה<br/>אבל נצטרך להמשיך עם נציג</>);
                pageContent.isDisplayCallBack = true;
            break;
            //SUCCESS
            case PageEnum.SUCCESS:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Completed', messageText: dwhWizardName + ' Answer Display', param1: resultMessage }));
                pageContent.type = PageEnum.SUCCESS;
            break;
            //CALLBACK
            case PageEnum.CALLBACK:
                pageContent.type = PageEnum.CALLBACK;
            break;
            //LOADER
            case StepsEnum.UPDATING_SETTINGS:
                thunkAPI.dispatch(hideAppLoader());
                pageContent.type = PageEnum.LOADER;
                pageContent.title = 'מרעננים הגדרות';
            break;
            case StepsEnum.START_TROUBLESHOOTING_WIZARD_LOADER:
                pageContent.type = PageEnum.LOADER;
                pageContent.title = 'בודקים כמה דברים לפני שנמשיך';
            break;
            //SUBSCRIBERS
            case PageEnum.SUBSCRIBERS:
                thunkAPI.dispatch(reportDWH({ actionType: dwhWizardName + ' Page', status: 'Ongoing', messageText: dwhWizardName + ' Start Running'}));
                pageContent.type = PageEnum.SUBSCRIBERS;
            break;
            default:
            break;
        };

        if(pageType != StepsEnum.SHOW_EXTENDED_OTP_POPUP){
            thunkAPI.dispatch(goToPage({page: pageContent.type , pageContent: pageContent}));
        }

    } catch (error) {
        console.error(error);
    } finally {
    }
});


export const onClickPopupButton = createAsyncThunk('localCellularTroubleshootingWizardBlock/onClickPopupButton', async (data, thunkAPI) => {
    try{
        const localCellularTroubleshootingWizardBlock = thunkAPI.getState().localCellularTroubleshootingWizardBlock;
        const popupType = localCellularTroubleshootingWizardBlock.pageContent?.popup.type;
        switch(popupType){
            case PopupTypeEnum.HOW_TO_CALL_FROM_ISRAEL:
                thunkAPI.dispatch(setIsShowPopup(false));
                break;
            default:
                break;
        }

    }catch(error) {
        console.error(error);
    } finally {
    }
});


export const startTroubleshootingWizard = createAsyncThunk('localCellularTroubleshootingWizardBlock/StartTroubleshootingWizard', async (data, thunkAPI) => {
      try {
        thunkAPI.dispatch(goToPageAsync({pageType: StepsEnum.START_TROUBLESHOOTING_WIZARD_LOADER }));
        const blockState = thunkAPI.getState().localCellularTroubleshootingWizardBlock;
        const subscriber = blockState.subscriber;
        const wizardTypeName = blockState.wizardTypeName;
        const dwhWizardName = blockState.dwhWizardName;
        thunkAPI.dispatch(getSubscriberDetails(subscriber));

        //Setup SignalR connection with correct event name
        const eventCallbacks = {
            Update: (data) => {
                console.log('Received Update event with data:', data);
                if (data.step) {
                    console.log('Dispatching setTroubleshootingStep with:', data.step);
                    thunkAPI.dispatch(goToPageAsync({pageType: data.step}));
                }
                if (data.message) {
                    console.log('Message from backend:', data.message);
                }
            }
        };

        signalRService.setupConnection(subscriber, SignalRConstants.Groups.TROUBLESHOOTING, eventCallbacks);

        const request = {
          subscriberNumber: subscriber,
          process: wizardTypeName
        };
        const response =  await ProviderManager.getProviderData('startTroubleshootingWizard', request);

        if(response.Body.isSuccess){
            if(wizardTypeName == WizardEnum.LocalCalls){
                thunkAPI.dispatch(goToPageAsync({pageType: StepsEnum.SELECT_CALLS_TYPE }));
            }else if(wizardTypeName == WizardEnum.LocalData){
                thunkAPI.dispatch(goToPageAsync({pageType: ErrorsEnum.NO_ERROR_DATA, resultMessage: response.Body.resultMessage }));
            }else if(wizardTypeName == WizardEnum.LocalMabal){
                thunkAPI.dispatch(goToPageAsync({pageType: ErrorsEnum.NO_ERROR_MABAL, details: response.Body.data, resultMessage: response.Body.resultMessage }));
            }

        }else{
            thunkAPI.dispatch(goToPageAsync({pageType: response.Body.resultCode , details: response.Body.data, resultMessage: response.Body.resultMessage  }));
        }

        return response;

      } catch (error) {
        thunkAPI.dispatch(goToPageAsync({pageType: ErrorsEnum.GENERAL_ERROR, resultMessage: 'שגיאה כללית' }));
      } finally{
        thunkAPI.dispatch(hideAppLoader());
      }
    }
  );


export const internationalCallUnblocking = createAsyncThunk('localCellularTroubleshootingWizardBlock/internationalCallUnblocking', async (data, thunkAPI) => {
    try {

      const blockState = thunkAPI.getState().localCellularTroubleshootingWizardBlock;
      const subscriber = blockState.subscriber;
      const dwhWizardName = blockState.dwhWizardName;

      const request = {
        subscriber: subscriber,
      };
      const response =  await ProviderManager.getProviderData('internationalCallUnblocking', request);

      if(response.Body.isSuccess){
          thunkAPI.dispatch(goToPageAsync({pageType: StepsEnum.OPEN_OUTGOING_CALLS_MABAL_SUCCESS}));
      }else{
        thunkAPI.dispatch(goToPageAsync({pageType: ErrorsEnum.ACTION_FAILED, messageText : 'OpenInternationalCallsBlock Error'}));
      }

      return response;

    } catch (error) {
      thunkAPI.dispatch(goToPageAsync({pageType: ErrorsEnum.GENERAL_ERROR,  resultMessage: 'שגיאה כללית'}));
    } finally{
      thunkAPI.dispatch(hideAppLoader());
    }
  }
);


export const localCallsTroubleshootingWizard = createAsyncThunk('localCellularTroubleshootingWizardBlock/LocalCallsTroubleshootingWizard', async (data, thunkAPI) => {
    try {
      const blockState = thunkAPI.getState().localCellularTroubleshootingWizardBlock;
      const subscriber = blockState.subscriber;
      const dwhWizardName = blockState.dwhWizardName;
      const localCallsType = data.localCallsType;


      //Setup SignalR connection with correct event name
      const eventCallbacks = {
          Update: (data) => {
              console.log('Received Update event with data:', data);
              if (data.step) {
                  console.log('Dispatching setTroubleshootingStep with:', data.step);
                  thunkAPI.dispatch(goToPageAsync({pageType: data.step}));
              }
              if (data.message) {
                  console.log('Message from backend:', data.message);
              }
          }
      };

      signalRService.setupConnection(subscriber, SignalRConstants.Groups.TROUBLESHOOTING, eventCallbacks);

      const request = {
        subscriberNumber: subscriber,
        process: localCallsType
      };
      const response =  await ProviderManager.getProviderData('localCallsTroubleshootingWizard', request);

      if(response.Body.isSuccess){
          if(localCallsType == WizardEnum.LocalIncomingCalls){
              thunkAPI.dispatch(goToPageAsync({pageType: ErrorsEnum.NO_ERROR_INCOMING_CALLS, resultMessage: response.Body.resultMessage }));
          }else if(localCallsType == WizardEnum.LocalOutgoingCalls){
              thunkAPI.dispatch(goToPageAsync({pageType: ErrorsEnum.NO_ERROR_OUTGOING_CALLS , resultMessage: response.Body.resultMessage  }));
          }
      }else{
          thunkAPI.dispatch(goToPageAsync({pageType: response.Body.resultCode , details: response.Body.data , resultMessage: response.Body.resultMessage  }));
      }

      return response;

    } catch (error) {
      thunkAPI.dispatch(goToPageAsync({pageType: ErrorsEnum.GENERAL_ERROR, resultMessage: 'שגיאה כללית' }));
    } finally{
      thunkAPI.dispatch(hideAppLoader());
    }
  }
);
